import { Injectable, Injector, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorService } from '../../services/error.service';
import { LogService } from '../../services/log.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  private LOG: LogService = new LogService(ErrorHandlerService);
  constructor(
    private injector: Injector,
    private ngZone: NgZone,
    private errorService: ErrorService
  ) {
  }

  handleError(error: any): void {
    const router = this.injector.get(Router);
	// dans le cas ExpressionChangedAfterItHasBeenCheckedError rien à faire
    this.LOG.error(error);
    if (error.code && error.code === '100') {
      return;
    }
    if (error.code === 0) {
      /*const modalRef = this.modalService.open(InformationComponent);
      modalRef.componentInstance.title = "Erreur lors de l'appel au serveur";
      modalRef.componentInstance.content = "La requête n'a pas reçu de réponse à temps : " + error;
      modalRef.componentInstance.OkOuRetour = true;*/
      this.LOG.error("Erreur lors de l'appel au serveur");
      this.LOG.error("La requête n'a pas reçu de réponse à temps : " + error);
      return;
    }
	if(error.status!='404'){
    this.errorService.error = error.message;
    this.ngZone.run(() => {
      router.navigateByUrl('/erreur');
    });
	}
  }
}
